import * as React from 'react';
import HeaderNavigation from '../../../headers/HeaderNavigation/HeaderNavigation';
import UserInfo from '../../../headers/UserInfo/UserInfo';
import PageHeader from '../../../headers/PageHeader/PageHeader';
import HeaderPartSeparator from '../../../headers/HeaderPartSeparator/HeaderPartSeparator';
import ComboBox from '../../../components/ComboBox/ComboBox';
import CompareVersionTagItem from '../CompareVersionTagItem/CompareVersionTagItem';
import { IProject } from '../../../../models/IProject';
import { isCiCdTag } from '../../../../services/mini/isCiCdTag';
import { Environment } from '../../../../const/environment';

type CompareModeHeaderProps = {
    project: IProject
    fromTagId: string
    toTagId: string
    environment: Environment
    compareVersions: (fromTagId: string, toTagId: string) => void
}

function CompareModeHeader({ project, fromTagId, toTagId, environment, compareVersions }: CompareModeHeaderProps) {

    const changeFromVersionCb = React.useCallback((tag) => {
        if (tag.tagId !== fromTagId) {
            compareVersions(tag.tagId, toTagId);
        }
    }, [fromTagId, toTagId, compareVersions]);

    const changeToVersionCb = React.useCallback((tag) => {
        if (tag.tagId !== toTagId) {
            compareVersions(fromTagId, tag.tagId);
        }
    }, [fromTagId, toTagId, compareVersions]);

    const tags = project?.tags?.filter((tag) => {
        return !isCiCdTag(tag);
    }) || [];

    return <PageHeader
        leftPart={
            <React.Fragment>
                <HeaderNavigation />
                {fromTagId && toTagId &&
                    <div className="compare-mode-header">
                        <HeaderPartSeparator height={32} />
                        <div className="compare-mode-header_versions">
                            <div className="compare-mode-header_versions_version-to-holder">
                                <ComboBox values={tags}
                                    size="small"
                                    valueKey="tagId"
                                    selectedValueId={toTagId}
                                    onValueSelect={changeToVersionCb}
                                    valueName="message"
                                    environment={environment}
                                    tooltipMsg="Select version for comparing"
                                    tooltipId="compareVersionToCbTooltip"
                                    renderItem={(tag) => {
                                        return <CompareVersionTagItem
                                            tag={tag}
                                        />;
                                    }}
                                />
                            </div>
                            <div className="compare-mode-header_versions_version-from-holder">
                                <ComboBox values={tags}
                                    size="small"
                                    valueKey="tagId"
                                    selectedValueId={fromTagId}
                                    onValueSelect={changeFromVersionCb}
                                    valueName="message"
                                    environment={environment}
                                    tooltipMsg="Select version for comparing"
                                    tooltipId="compareVersionFromCbTooltip"
                                    renderItem={(tag) => {
                                        return <CompareVersionTagItem
                                            tag={tag}
                                        />;
                                    }}
                                />
                            </div>
                        </div>
                    </div>}
            </React.Fragment>
        }
        rightPart={
            <React.Fragment>
                <UserInfo hideBalanceBlock={true} />
            </React.Fragment>
        }
    />;
}

export default CompareModeHeader;